export default "__VITE_ASSET__I3x6Acty__"